<main class="sh-page sh-fund" *ngIf="showPage">
  <!-- HERO -->
  <header class="sh-hero" [style.background-image]="content.hero.image ? 'url(' + content.hero.image + ')' : null">
    <div class="sh-hero__overlay"></div>
    <div class="sh-wrap sh-hero__inner">
      <span class="sh-eyebrow sh-eyebrow--light">{{ content.hero.eyebrow }}</span>
      <h1 class="sh-display">{{ content.hero.title }}</h1>
      <p class="sh-tagline">{{ content.hero.tagline }}</p>
      <p class="sh-hero__lede">{{ content.hero.lede }}</p>
      <div class="sh-btn-row">
        <a class="sh-btn sh-btn--blue" href="#fund-form">{{ content.hero.ctaPrimaryLabel }}</a>
        <a class="sh-btn sh-btn--outline-light" [href]="content.oneSheetUrl" target="_blank" rel="noopener">
          Download the One-Sheet
        </a>
      </div>
    </div>
  </header>

  <!-- HOW IT WORKS -->
  <section class="sh-section">
    <div class="sh-wrap sh-two-col">
      <div>
        <div class="sh-section-head"><span class="sh-bar"></span><h2>{{ content.howItWorks.heading }}</h2></div>
        <p class="sh-lede">{{ content.howItWorks.intro }}</p>
      </div>
      <div class="sh-rental-card">
        <h3>{{ content.howItWorks.includesHeading }}</h3>
        <ul class="sh-check-list">
          <li *ngFor="let item of content.howItWorks.includes">{{ item }}</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- WHY FUNDRAISE WITH US -->
  <section class="sh-section sh-section--tight">
    <div class="sh-wrap">
      <div class="sh-section-head"><span class="sh-bar"></span><h2>{{ content.whyUs.heading }}</h2></div>
      <p class="sh-lede">{{ content.whyUs.intro }}</p>
      <div class="sh-stat-strip">
        <div *ngFor="let s of content.whyUs.stats"><span class="sh-stat">{{ s.value }}</span><span class="sh-stat__label">{{ s.label }}</span></div>
      </div>
    </div>
  </section>

  <!-- DECADE OF GIVING -->
  <section class="sh-section sh-section--tight">
    <div class="sh-wrap">
      <div class="sh-section-head"><span class="sh-bar"></span><h2>{{ content.decade.heading }}</h2></div>
      <p class="sh-lede">{{ content.decade.intro }}</p>
    </div>
  </section>

  <!-- PHOTO BAND -->
  <section class="sh-section sh-section--tight" *ngIf="content.photos.length">
    <div class="sh-wrap">
      <div class="sh-photo-band">
        <img *ngFor="let src of content.photos" [src]="src" alt="Steelhaus community fundraiser" width="800" height="600" loading="lazy" decoding="async" />
      </div>
    </div>
  </section>

  <!-- ONE-SHEET CALLOUT -->
  <section class="sh-section sh-section--tight">
    <div class="sh-wrap">
      <div class="sh-callout">
        <div>
          <h3>{{ content.oneSheetCallout.heading }}</h3>
          <p>{{ content.oneSheetCallout.text }}</p>
        </div>
        <a class="sh-btn sh-btn--outline-dark" [href]="content.oneSheetUrl" target="_blank" rel="noopener">
          Download PDF One-Sheet
        </a>
      </div>
    </div>
  </section>

  <!-- REQUEST FORM -->
  <section class="sh-section" id="fund-form">
    <div class="sh-wrap sh-wrap--narrow">
      <div class="sh-section-head"><span class="sh-bar"></span><h2>{{ content.form.heading }}</h2></div>
      <p class="sh-lede">{{ content.form.intro }}</p>

      <div class="sh-form-card">
        <form [formGroup]="form" class="supportForm" (ngSubmit)="onSubmit()">
          <div class="sh-form-grid">
            <label>Organizer Name*<input type="text" formControlName="organizer" />
              <span class="sh-err" *ngIf="isInvalid('organizer')">Please enter your name.</span>
            </label>
            <label>Organization / Foundation*<input type="text" formControlName="organization" />
              <span class="sh-err" *ngIf="isInvalid('organization')">Please enter your organization.</span>
            </label>
            <label>Organizer Email*<input type="email" formControlName="email" />
              <span class="sh-err" *ngIf="isInvalid('email')">Please enter a valid email.</span>
            </label>
            <label>Organizer Phone*<input type="tel" formControlName="phone" />
              <span class="sh-err" *ngIf="isInvalid('phone')">Please enter a phone number.</span>
            </label>
            <label>Preferred Date 1*<input type="date" formControlName="date1" />
              <span class="sh-err" *ngIf="isInvalid('date1')">Please choose a date.</span>
            </label>
            <label>Preferred Date 2<input type="date" formControlName="date2" /></label>
          </div>

          <fieldset class="sh-fieldset">
            <legend>Is this for a registered non-profit or foundation?*</legend>
            <label class="sh-radio-pill"><input type="radio" formControlName="nonprofit" value="Yes" /> Yes</label>
            <label class="sh-radio-pill"><input type="radio" formControlName="nonprofit" value="No" /> No</label>
            <span class="sh-err d-block" *ngIf="isInvalid('nonprofit')">Please choose one.</span>
          </fieldset>

          <label class="sh-block">Anything else we should know?
            <textarea rows="4" formControlName="details" placeholder="Optional — share any additional details about your event"></textarea>
          </label>

          <div class="captcha-wrapper">
            <ngx-recaptcha2
              formControlName="captchaResponseControl"
              [siteKey]="siteKey"
              (ngxCaptchaCallback)="handleSuccess($event)"
              (ngxCaptchaExpired)="handleExpire()"
              (ngxCaptchaLoad)="handleLoad()"
            ></ngx-recaptcha2>
            <a href="javascript:void(0)" (click)="resetCaptcha()">
              reset
            </a>
          </div>
          <div *ngIf="isInvalid('captchaResponseControl')" class="sh-err">
            Captcha is required
          </div>

          <!-- Never use [disabled] here: site CSS can keep disabled buttons looking enabled. -->
          <button
            type="submit"
            class="sh-btn sh-btn--blue support-submit"
            [attr.aria-busy]="submitting"
          >
            <span *ngIf="submitting">Sending…</span>
            <span *ngIf="!submitting">Submit Request</span>
          </button>

          <div *ngIf="success" class="alert alert-success mt-3">
            {{ content.form.successNote || 'Form submitted successfully' }}
          </div>

          <div *ngIf="error" class="alert alert-danger mt-3">
            {{ error }}
          </div>

          <p class="sh-form-alt">
            Prefer Google's own form?
            <a [href]="content.googleFormUrl" target="_blank" rel="noopener">Open it in a new tab</a>.
          </p>
        </form>
      </div>
    </div>
  </section>
</main>

<div class="sh-unavailable sh-wrap" *ngIf="!showPage">
  <h2>Page not available</h2>
  <p>This page isn't enabled for this location.</p>
  <a routerLink="/" class="sh-btn sh-btn--blue">Back to Home</a>
</div>
